"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewSourceNames = exports.DefaultVerificationLevels = exports.SourceGroups = void 0;
var SourceGroups;
(function (SourceGroups) {
    SourceGroups["AutomaticInvitation"] = "automatic-invitation";
    SourceGroups["BasicInvitation"] = "basic-invitation";
    SourceGroups["EmbeddedReviewForm"] = "embedded-review-form";
    SourceGroups["GeneratedLink"] = "generated-link";
    SourceGroups["ManualInvitation"] = "manual-invitation";
    SourceGroups["Organic"] = "organic";
})(SourceGroups || (exports.SourceGroups = SourceGroups = {}));
var DefaultVerificationLevels;
(function (DefaultVerificationLevels) {
    DefaultVerificationLevels["Invited"] = "invited";
    DefaultVerificationLevels["NotVerified"] = "not-verified";
    DefaultVerificationLevels["Redirected"] = "redirected";
    DefaultVerificationLevels["Verified"] = "verified";
})(DefaultVerificationLevels || (exports.DefaultVerificationLevels = DefaultVerificationLevels = {}));
var ReviewSourceNames;
(function (ReviewSourceNames) {
    ReviewSourceNames["LegacyAfsName"] = "AFS";
    ReviewSourceNames["LegacyKickstartName"] = "Kickstart";
    ReviewSourceNames["LegacyTrustpilotName"] = "Trustpilot";
    ReviewSourceNames["LegacyUniqueLinkName"] = "UniqueLink";
    ReviewSourceNames["Afsv1Name"] = "AFSv1";
    ReviewSourceNames["Afsv2Name"] = "AFSv2";
    ReviewSourceNames["BannerRedirect"] = "BannerRedirect";
    ReviewSourceNames["BasicLinkName"] = "BasicLink";
    ReviewSourceNames["BigCommerceName"] = "BigCommerce";
    ReviewSourceNames["BusinessGeneratedLinkName"] = "BusinessGeneratedLink";
    ReviewSourceNames["CopyPasteInvitationName"] = "CopyPasteInvitation";
    ReviewSourceNames["DomainLinkName"] = "DomainLink";
    ReviewSourceNames["EmbeddedUniqueLinkFormName"] = "EmbeddedUniqueLinkForm";
    ReviewSourceNames["EmbeddedBusinessGeneratedLinkFormName"] = "EmbeddedBusinessGeneratedLinkForm";
    ReviewSourceNames["FileUploadInvitationName"] = "FileUploadInvitation";
    ReviewSourceNames["InvitationApiName"] = "InvitationApi";
    ReviewSourceNames["InvitationLinkApiName"] = "InvitationLinkApi";
    ReviewSourceNames["UniqueLinkName"] = "LegacyUniqueLink";
    ReviewSourceNames["MagentoName"] = "Magento";
    ReviewSourceNames["ManualInputInvitationName"] = "ManualInputInvitation";
    ReviewSourceNames["OrganicName"] = "Organic";
    ReviewSourceNames["ShopifyName"] = "Shopify";
    ReviewSourceNames["WooCommerceName"] = "WooCommerce";
    ReviewSourceNames["InvitationScript"] = "InvitationScript";
    ReviewSourceNames["PrestaShop"] = "PrestaShop";
    ReviewSourceNames["MagentoV1"] = "MagentoV1";
    ReviewSourceNames["MagentoV2"] = "MagentoV2";
    ReviewSourceNames["OpenCart"] = "OpenCart";
    ReviewSourceNames["Segment"] = "Segment";
    ReviewSourceNames["Shopware"] = "Shopware";
    ReviewSourceNames["Wix"] = "Wix";
    ReviewSourceNames["GoogleTagManager"] = "GTM";
    ReviewSourceNames["PayPal"] = "PayPal";
    ReviewSourceNames["Square"] = "Square";
    ReviewSourceNames["Salesforce"] = "Salesforce";
    ReviewSourceNames["HubSpot"] = "HubSpot";
    ReviewSourceNames["VerifiedWidgetForm"] = "VerifiedWidgetForm";
})(ReviewSourceNames || (exports.ReviewSourceNames = ReviewSourceNames = {}));
